export default __webpack_public_path__ + "static/media/logo.5fdd64a2.png";